import BaseApi from './BaseApi'

class KnowsHowMuchToInvestOptionsApi extends BaseApi {
  get knowsHowMuchToInvestOptionsUrl () {
    return 'knowsHowMuchToInvestOptions'
  }

  fetchingKnowsHowMuchToInvestOptions (knowsHowMuchToInvestOptions) {
    return this.getJson(this.knowsHowMuchToInvestOptionsUrl, knowsHowMuchToInvestOptions)
  }
}
export default KnowsHowMuchToInvestOptionsApi
